<template>
    <md-field>
        <label :for="id">{{$t(label)}}</label>
        <md-file
                :name="id"
                :id="id"
                :accepts="accepts"
                :multiple="multiple"
                ref="native"
                @input="$emit('input', $refs.native.model)"
                :disabled="disabled"
        />
        <span class="md-helper-text" v-if="helperText">{{$t(helperText)}}</span>
        <span class="md-error">{{$t(description || 'Validation.genericError')}}</span>
    </md-field>
</template>

<script>
    export default {
      props: {
        id: String,
        label: {},
        disabled: Boolean,
        accepts: {type: [String, Array], default: ''},
        multiple: {type: Boolean, default: false},
        description: {},
        helperText: {},
      },
      methods: {
        getFiles() {
          return [... this.$refs.native?.$refs?.inputFile?.files ?? [] ]
        }
      }
    }
</script>
